import moment from 'moment';
import angular from 'angular';
import nsjGlobals from '../../../../core/globals/nsj-globals';
import { IMovimentacaoFormModel } from '../components/movimentacao-form/movimentacoes-movimentacao-form.model';
import { IMovimentacaoPeriodo } from '../../models/movimentacoes-periodos.service.model';

type TDataPagamentoWindow = {
    minDate: string | null;
    maxDate: string | null;
};

export function normalizeMovimentacaoDate(value: string | Date | null | undefined): string | null {
    if (!value) {
        return null;
    }

    if (value instanceof Date) {
        const parsed = moment(value);
        return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
    }

    const parsed = moment(value, ['DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null;
}

export function createEmptyMovimentacaoForm(): IMovimentacaoFormModel {
    return angular.copy({
        trabalhador: null,
        evento: null,
        lotacao: null,
        valor: null,
        referencia: '',
        datapagamento: null,
        vigencia: 1,
        vigenciamesfinal: null,
        vigenciaanofinal: null
    });
}

export function isMovimentacaoDataPagamentoEnabled(): boolean {
    const configs = nsjGlobals.get('configuracoes');
    return !!(configs && configs['MOVIMENTO_DATAPAGAMENTO']);
}

export function isMovimentacaoPeriodoEncerrado(periodo: IMovimentacaoPeriodo | null | undefined): boolean {
    return Number(periodo?.situacao) === 2;
}

export function buildMovimentacaoDataPagamentoWindow(
    periodo: IMovimentacaoPeriodo | null | undefined
): TDataPagamentoWindow {
    if (!periodo) {
        return {
            minDate: null,
            maxDate: null
        };
    }

    const inicio = moment({
        year: Number(periodo.ano),
        month: Number(periodo.mes) - 1,
        day: 1
    });

    if (!inicio.isValid()) {
        return {
            minDate: null,
            maxDate: null
        };
    }

    return {
        minDate: inicio.startOf('month').format('YYYY-MM-DD'),
        maxDate: inicio.clone().add(1, 'month').endOf('month').format('YYYY-MM-DD')
    };
}

export function isMovimentacaoPeriodoMesAtual(periodo: IMovimentacaoPeriodo | null | undefined): boolean {
    if (!periodo) {
        return false;
    }

    const now = moment();
    return Number(periodo.ano) === now.year() && Number(periodo.mes) === now.month() + 1;
}
